<template>
  <slot
    :toggle="toggle"
    :loading="loading"
    :disabled="disabled"
  />
</template>

<script setup lang="ts">
import { useRenderNotifier } from '@wui/common-library'
import { useIM } from '@wui/im'
import { computed, ref } from 'vue'

import { useNotificationPreferenceStore } from '@/entities/room'

import { useGuestAuth } from '@/shared/composables/guest-auth'
import { isGuest } from '@/shared/composables/local-storage'
import { useLocalization } from '@/shared/composables/localization'

const props = defineProps<{
  pServed: string
}>()

const { notifyError } = useRenderNotifier()
const store = useNotificationPreferenceStore()
const { t } = useLocalization()
const { currentGuest } = useGuestAuth()

const isGuestUser = computed(() => isGuest() || Boolean(currentGuest.value))
const disabled = computed(() => store.getAccessByRoomId(props.pServed))
const loading = ref(false)
const toggle = () => {
  if (isGuestUser.value) {
    return
  }

  loading.value = true
  useIM().modificateChatPreference({
    command: disabled.value ? 'EnableNotification' : 'DisableNotification',
    to: props.pServed,
  }).catch((e) => {
    const errorMessage = e instanceof Error ? e.message : t('common.unknownError')
    notifyError(errorMessage)
  }).finally(() => {
    loading.value = false
  })
}
</script>
